var render = function render() {
  var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy;return _c('div', { staticClass: "fullscreen" }, [_c('span', { staticClass: "handler", on: { "click": function click() {
        if (!_vm.isFullscreen) {
          _vm.handleClick();
        } else {
          _vm.exitFullscreen();
        }
      } } }, [_vm.$slots.icon ? [_vm._t("icon")] : [_c('svg-icon', { attrs: { "icon-class": !_vm.isFullscreen ? 'fullScreen' : 'fullScreenExit', "size": _vm.size } })]], 2)]);
};
var staticRenderFns = [];

export { render, staticRenderFns };